// @flow
import api from 'tim-api';
import {
  logImportProcess as logImportProcessEndPoint
} from 'endPoints';

export const state = {
  filterLogImportProcessHistory: []
};

export const getters = {
  filterLogImportProcessHistory: (state: Object) => state.filterLogImportProcessHistory
};

export const mutations = {
  SET_IMPORT_PROCESS_HISTORY(state: Object, filterLogImportProcessHistory: Array<Object>) {
    state.filterLogImportProcessHistory = filterLogImportProcessHistory;
  }
};

export const actions = {
  fetchImportProcessHistory({ commit }: Action, filter: Object) {
    commit('SET_IMPORT_PROCESS_HISTORY', []);

    const url = `${logImportProcessEndPoint}`;
    return api.post(url, filter, {
      responseType: 'blob'
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
